<template>
  <transition
    name="modal"
    @before-enter="transitioning = true"
    @after-enter="transitioning = false"
    @before-leave="transitioning = true"
  >
    <div v-if="open" :class="classes">
      <div class="asd20-modal">
        <div v-if="title || $slots.title" class="asd20-modal__header">
          <asd20-icon v-if="icon" :name="icon" size="md" />
          <h2>{{ title }}<slot name="title" /></h2>

          <asd20-button
            v-if="dismissable"
            size="md"
            icon="close"
            label="Close"
            hide-label
            transparent
            @click.native="$emit('dismiss', false)"
          />
        </div>
        <slot name="header" />
        <div class="asd20-modal__content">
          <slot name="default" :transitioning="transitioning" />
          <slot name="main" />
        </div>
        <div class="asd20-modal__footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Asd20Icon from '../../atoms/Asd20Icon'
import Asd20Button from '../../atoms/Asd20Button'
export default {
  name: 'Asd20Modal',
  components: { Asd20Icon, Asd20Button },
  model: { prop: 'open', event: 'dismiss' },
  props: {
    open: { type: Boolean, default: false },
    icon: { type: String, default: '' },
    title: { type: String, default: '' },
    dismissable: { type: Boolean, default: false },
    windowed: { type: Boolean, default: false },
  },
  data: () => ({
    transitioning: false,
  }),
  computed: {
    classes() {
      return {
        'asd20-modal-container': true,
        'asd20-modal-container--windowed': this.windowed,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

.asd20-modal-container {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(black, 0.5);

  display: flex;
  justify-content: center;
  align-items: stretch;
}

.asd20-modal {
  position: relative;
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  max-width: 100vw;
  max-height: 100vh;

  background: var(--website-page__background-color);
}
.asd20-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  border-bottom: 1px solid var(--color__tertiary);
  & > .asd20-icon {
    margin: 0 space(0.5);
  }
  h2 {
    margin: space(0.5);
    font-size: 1rem;
    flex-grow: 1;
  }
}

.asd20-modal__footer {
  display: flex;
  align-items: center;
  background: var(--website-page__alternate-background-t50);
  p {
    margin-bottom: 0;
  }
}

.asd20-modal__content {
  display: flex;
  flex-direction: column;
  position: relative;
  flex-grow: 1;
  overflow: hidden;
}

// Overlay/container transition
.modal-enter-active {
  transition: all asd20-speed(3) ease-out;
}
.modal-leave-active {
  transition: all asd20-speed(3) $anim-easing;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}

// Modal transition
.modal-enter-active .asd20-modal {
  transition: all asd20-speed(2) $anim-easing asd20-speed(1);
}
.modal-leave-active .asd20-modal {
  transition: all asd20-speed(1) $anim-easing;
}

.modal-enter .asd20-modal,
.modal-leave-to .asd20-modal {
  transform: scale3d(0, 0, 0) translate3d(0, 100%, 0);
  opacity: 0;
}

@media (min-width: 1200px) {
  .asd20-modal {
    // padding: space(2) space(2) 0 space(2);
    border-radius: var(--website-shape__radius-m);
  }
  .asd20-modal-container {
    &--windowed {
      padding: space(3);
    }
  }
}
</style>
